import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { colors, radii } from '../../styles/tokens';

export interface ToolSectionCardProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export const ToolSectionCard: React.FC<ToolSectionCardProps> = ({
  title,
  description,
  children,
  actions,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: colors.paper,
        border: `1px solid ${colors.border}`,
        borderRadius: `${radii.card}px`,
        p: { xs: 2, sm: 3 },
        boxShadow: 'none',
        width: '100%',
      }}
    >
      {(title || description || actions) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'flex-start' },
            justifyContent: 'space-between',
            gap: 1.5,
            mb: title || description ? 2 : 0,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {title && (
              <Typography
                variant="subtitle1"
                component="h2"
                sx={{ fontWeight: 700, color: colors.textPrimary, mb: description ? 0.5 : 0 }}
              >
                {title}
              </Typography>
            )}
            {description && (
              <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.6 }}>
                {description}
              </Typography>
            )}
          </Box>
          {actions && (
            <Box sx={{ flexShrink: 0, alignSelf: { xs: 'stretch', sm: 'center' } }}>{actions}</Box>
          )}
        </Box>
      )}
      <Box>{children}</Box>
    </Paper>
  );
};
